import Template from '../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer, toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import Select from 'react-select'; //04-03-2024-multiselect
import 'react-toastify/dist/ReactToastify.css';
import '../../Assets/css/resptable.css'
import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import $ from 'jquery';
import DownloadLoader from '../../component/DownloadLoader.js';
import { disciplineStyles } from "../../Assets/js/customStyles.js";

export default function CollegeStudentCOAttainment() {

  const navigate = useNavigate();
  // CHECKING IF USER IS VALID
  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/college/")
  }

  const tableRef = useRef(null);
  const [disciplinedata, setDisciplineData] = useState([]);
  const [studentData, setStudentData] = useState([]);
  const [flag, setflag] = useState(false);
  const [getexamData, setExamData] = useState([]);
  const [errors, setErrors] = useState({ admyear: '', discipline_id: '' });
  const [admissionYears, setAdmissionYears] = useState([]);
  const [admissionYear, setAdmissionYear] = useState(null);
  const [selectedAdmissionYear, setSelectedAdmissionYear] = useState(null);
  const [selectedExamId, setSelectedExamId] = useState([]);
  const [selectExamId, setSelectExamId] = useState(false);
  const [tableData, setTableData] = useState({});
  const [disciplineId, setDisciplineId] = useState(null);
  const [disciplineName, setDisciplineName] = useState(null);
  const [DisciplineTypeChange, setDisciplineTypeChange] = useState(null);
  const [studentsList, setStudentsList] = useState([]);
  const [totalstudents, setTotalStudents] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);
  const [loading, setloading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort

  const { http } = Api();
  useEffect(() => {
    const fetchAdmissionYears = async () => {
      try {
        const response = await http.get('/Admin/getActiveAdmissionYear');
        const years = response.data.map((year) => ({
          id: year.id,
          value: year.admission_year,
          label: year.admission_year
        }));
        setAdmissionYears(years);
      } catch (error) {
        console.error("Error fetching admission years:", error);
      }
    };
    fetchAdmissionYears();
  }, [admissionYear]);

  const handleAdmissionYearChange = (selectedOption) => {
    setAdmissionYear(selectedOption.value);
    setSelectedAdmissionYear(selectedOption);
  };
  let username = localStorage.getItem("username");

  useEffect(() => {
    const fetchExamData = () => {
      http
        .get('/getActiveExam', {
          params: {
            exam_year: admissionYear
          }
        })
        .then((response) => {
          setExamData(response.data.activeexam);
        })
        .catch((error) => {
          const status = error.response?.data?.http_status;
          const message = error.response?.data?.message || "Something went wrong";

          if (status === 401 && error.response?.data?.status_code === "ERR9") {
            toast.error("Invalid Token");
            setTimeout(() => navigate("/"), 5000);
          } else if (status === 429 && error.response?.data?.status_code === "ERR33") {
            toast.error(message);
          } else if (status === 500 && error.response?.data?.status_code === "ERR5") {
            toast.error("No active exam found");
            setExamData([]);
            setSelectedExamId([]);
            setSelectExamId(false);
          } else {
            toast.error(message);
          }
        });
    };

    fetchExamData();
  }, [admissionYear]);

  const handleChangeExam = (selectedOption) => {
    setSelectedExamId([selectedOption]);
    setSelectExamId(selectedOption.value);
  }

  useEffect(() => {
    const fetchData = () => {
      http.get(`/College/getCollegeDisciplineforCo`, {
        params: {
          examid: selectExamId,
        }
      }).then((response) => {
        if (response.data.status_code === 'ERR5') {
          setflag(true);
        }
        setDisciplineData(response.data.result);
      }).catch((error) => {
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);
        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else {
          toast.error("Something went wrong");
        }
        console.error('Error fetching Course data:', error);
      }
      )
    };
    if (selectExamId) {
      fetchData();
    }
  }, [selectExamId]);

  const handleDisciplineChange = (selectedOptions) => {

    const [id, type] = selectedOptions.value.split('-'); // Split the combined value
    setDisciplineId(parseInt(id));
    setDisciplineName(selectedOptions.label);
    setDisciplineTypeChange(type);
  };

  useEffect(() => {
    const fetchStudentList = () => {

      http.get(`/College/getStudentListByYearExamDiscipline?page=${currentPage}`, {
        params: {
          limit: '50',
          // admission_year: admissionYear,
          examid: selectExamId,
          discipline_id: disciplineId,
          discipline_type: DisciplineTypeChange
        }
      }).then((response) => {

        setStudentsList(response.data.result);
        setStudentData(response.data.studentlist.data);
        setTotalPages(Math.ceil(response.data.studentlist.total / 50));
        setTotalStudents(response.data.studentlist.total);

      }).catch((error) => {
        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "Something went wrong";

        if (status === 401 && error.response?.data?.status_code === "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/"), 5000);
        } else if (status === 429 && error.response?.data?.status_code === "ERR33") {
          toast.error(message);
        } else if (status === 500 && error.response?.data?.status_code === "ERR5") {
          toast.error("No data found");
          setStudentData([]);
          setTotalPages(1);
          setCurrentPage(1);
          setTotalStudents(null);

        } else {
          toast.error(message);
        }
      })
    };

    if (selectExamId && disciplineId) {
      fetchStudentList()
    }

  }, [selectExamId, disciplineId, currentPage, DisciplineTypeChange]);

  const handleSort = (column) => {
    const newSortBy = {
      column,
      direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
    };
    setSortBy(newSortBy);
  };

  useEffect(() => {
    const filteredAndSortedData = [...studentData].filter(student => {
      return (
        String(student.apaar_no)?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        String(student.accountid)?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        String(student.aadhar_no)?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        String(student.studentname)?.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }).sort((a, b) => {
      if (sortBy.direction === 'asc') {
        return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
      } else {
        return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
      }
    });
    setfilteredAndSortedData(filteredAndSortedData);
  }, [searchQuery, sortBy, studentData]);

  // Function to render sort icon-sort05/03/2024
  const renderSortIcon = (columnName) => {
    if (sortBy.column === columnName) {
      return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
    }
    return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
  };

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  useEffect(() => {
    const fetchTableData = () => {
      http
        .get('Student/getStudentcoAttainment', {
          params: {
            examid: selectExamId
          }
        })
        .then((response) => {
          setTableData(response.data.result);

        })
        .catch((error) => {
          const status = error.response?.data?.http_status;
          const message = error.response?.data?.message || "Something went wrong";

          if (status === 401 && error.response?.data?.status_code === "ERR9") {
            toast.error("Invalid Token");
            setTimeout(() => navigate("/"), 5000);
          } else if (status === 429 && error.response?.data?.status_code === "ERR33") {
            toast.error(message);
          } else if (status === 500 && error.response?.data?.status_code === "ERR5") {
            toast.error("No active exam found");
          } else {
            toast.error(message);
          }
        });
    };
    if (selectExamId.length > 0) {
      fetchTableData();
    }

  }, [selectExamId]);

  const handleGeneratePDF = async (admissionYear, selectExamId, disciplineId) => {
    setloading(true);

    try {
      const response = await http.get('College/CollegeStudentCOAttainPdf', {
        params: {
          admission_year: admissionYear,
          examid: selectExamId,
          discipline_id: disciplineId,
          discipline_type: DisciplineTypeChange,
          total_count: totalstudents
        },
        responseType: 'blob', // Expect binary response
      });

      if (totalstudents && totalstudents <= 150) {
        if (response && response.data) {
          // Create a URL for the downloaded file
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;

          // Set the file name and download the PDF
          link.setAttribute('download', `${username}_${disciplineName}_StudentCOAttainment.pdf`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          setloading(false);
          toast.success('PDF generated successfully');
        }
      }
      else if (totalstudents && totalstudents > 150) {
        if (response && response.data) {
          // Create a URL for the downloaded ZIP file
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/zip' }));

          // Create a download link element
          const link = document.createElement('a');
          link.href = url;

          // Set the filename dynamically
          link.setAttribute('download', `${username}_${disciplineName}_StudentCOAttainment.zip`);

          // Append the link to the body and trigger the download
          document.body.appendChild(link);
          link.click();

          // Clean up: Remove the link and revoke the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          setloading(false);
          toast.success('ZIP file downloaded successfully');
        }
      }

    } catch (error) {
      setloading(false);
      if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college");
        }, 5000);
      }
      else if (error.response.status === 403 || error.response.data.status_code == "ERR37") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college");
        }, 5000);
      }
      else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR47") {
        toast.error(error.response.data.message);
      }
      else {
        console.error('Error generating PDF:', error);
        toast.error('Error generating PDF');
      }
    }
  };

  const encodeExamID = (examid) => {
    return btoa(`${examid}`);
  };
  const encodeAccountID = (accountid) => {
    return btoa(`${accountid}`);
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),
    /* Additional custom scrollbar styling for WebKit-based browsers */
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };

  return (
    <>
      <ToastContainer />
      <Template>

        {loading ? (
          <>

            {/* <div className="container-fluid">
            <div className="row justify-content-center align-items-center">
              <div className="col-sm-12">
                <div className="card h-100">
                  <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <div className="containeranimate">
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

            <DownloadLoader />
          </>

        ) : (

          <div className="adl-stl-page">
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="col-md-12">
                      <div className="card-header">
                        <div className="py-3 d-flex justify-content-between align-items-center ">
                          <h5>MGU-UGP/BBA/BCA(HONOURS) CO ATTAINMENT CALCULATION CHART</h5>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="card-body pdg">
                        <div className="table-responsive">
                          <form className="form theme-form">
                            <div className="card-body custom-input">
                              <div className="col">
                                <div className="row m-b-20">
                                  <div className="col-md-3">
                                    <label>Exam Year <span className="errorclr">*</span></label>

                                    <Select
                                      maxMenuHeight={200}
                                      menuPlacement="auto"
                                      id="discipline_id"
                                      name="discipline_id"
                                      className="form"
                                      styles={customStyles}
                                      options={admissionYears.map(Years => ({
                                        value: Years.value,
                                        label: Years.label,
                                      }))}
                                      value={selectedAdmissionYear}
                                      placeholder="Select exam year..."
                                      onChange={handleAdmissionYearChange}
                                    />
                                    {errors.admyear && <p className="text-danger">{errors.admyear}</p>}
                                  </div>
                                  <div className="col-md-6">
                                    <label>Exam<span className="errorclr">*</span></label>
                                    <Select
                                      maxMenuHeight={200}
                                      menuPlacement="auto"
                                      id="exam_id"
                                      name="exam_id"
                                      className="basic-select"
                                      classNamePrefix="select"
                                      onChange={handleChangeExam}
                                      options={getexamData.map(exam => ({
                                        value: exam.examid,
                                        label: exam.examtitle,
                                      }))}
                                      value={selectedExamId.length > 0 ? selectedExamId.map(exam => ({
                                        value: exam.value,
                                        label: exam.label,
                                      })
                                      ) : []}

                                      placeholder="Select an exam..."
                                    />
                                    {errors.discipline_id && <p className="text-danger">{errors.discipline_id}</p>}

                                  </div>
                                  <div className="col-md-3">
                                    <label>Discipline <span className="errorclr">*</span></label>
                                    <Select
                                      maxMenuHeight={200}
                                      menuPlacement="auto"
                                      id="discipline_id"
                                      name="discipline_id"
                                      className="form"
                                      styles={disciplineStyles}
                                      onChange={handleDisciplineChange}
                                      options={flag ? [{ value: '0', label: 'No data found' }] : disciplinedata
                                        .sort((a, b) => a.discipline_name.localeCompare(b.discipline_name))
                                        .map(disciplines => ({
                                          value: `${disciplines.discipline_id}-${disciplines.course_type}`, // Modified value
                                          label: disciplines.discipline_name,
                                          type: disciplines.course_type
                                        }))}
                                      value={disciplinedata
                                        .filter(discipline =>
                                          discipline.discipline_id === parseInt(disciplineId) &&
                                          discipline.course_type === DisciplineTypeChange
                                        )
                                        .map(discipline => ({
                                          value: `${discipline.discipline_id}-${discipline.course_type}`, // Modified value
                                          label: discipline.discipline_name,
                                          type: discipline.course_type
                                        }))}
                                    />
                                    {errors.discipline_id && <p className="text-danger">{errors.discipline_id}</p>}
                                  </div>
                                </div>
                              </div>
                              <div className='row'>
                                {filteredAndSortedData.length > 0 && (
                                  <div className="buttons-container m-b-20 nav-right">
                                    <button
                                      className="lbl2 btn btn-primary mt-3"
                                      onClick={() => handleGeneratePDF(admissionYear, selectExamId, disciplineId)}
                                      title="Download"
                                    >
                                      <i class="bi bi-arrow-down-square"></i>
                                    </button>
                                  </div>
                                )}
                                <div className='col-md-6 wdt' >
                                  <p>
                                    Showing {(currentPage - 1) * 50 + 1}{''}-
                                    {Math.min((currentPage - 1) * 50 + 50, totalstudents)} of {totalstudents} entries
                                  </p>
                                </div>
                                <div className='col-md-2 wdt' >
                                </div>
                                <div className='col-md-4 wdt' align='right'>
                                  <input
                                    type="text"
                                    value={searchQuery}
                                    onChange={handleSearchInputChange}
                                    placeholder="Search..."
                                    className='form-control'
                                  /></div>
                              </div>
                              <div class="table-container">
                                <table className="display dataTable table-striped table-bordered" ref={tableRef} id="dataTable">
                                  <thead>
                                    <tr className="bg-primary" style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                      <th onClick={() => handleSort('created_at')} width="10%" style={{ textAlign: 'center', verticalAlign: 'middle' }}>Sl No &nbsp;
                                        {renderSortIcon('created_at')} </th>

                                      <th onClick={() => handleSort('PRN')} width="" style={{ textAlign: 'center', verticalAlign: 'middle' }}>PRN &nbsp;
                                        {renderSortIcon('PRN')}</th>
                                      <th onClick={() => handleSort('apaar_no')} width="" style={{ textAlign: 'center', verticalAlign: 'middle' }}>APAAR Id &nbsp;
                                        {renderSortIcon('apaar_no')}</th>
                                      {/* <th width="20%" onClick={() => handleSort('accountid')} style={{ textAlign: 'center', verticalAlign: 'middle' }}>CAP Id/Account ID &nbsp;
                                        {renderSortIcon('accountid')}</th>
                                      <th onClick={() => handleSort('aadhar_no')} style={{ textAlign: 'center', verticalAlign: 'middle' }}>Aadhar No &nbsp;
                                        {renderSortIcon('aadhar_no')}</th> */}
                                      <th onClick={() => handleSort('studentname')} width="" style={{ textAlign: 'center', verticalAlign: 'middle' }}>Name &nbsp;
                                        {renderSortIcon('studentname')}</th>
                                      <th scope="col" style={{ textAlign: 'center', verticalAlign: 'middle' }}>View</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {filteredAndSortedData.length > 0 ? filteredAndSortedData.map((student, index) => {
                                      const serialNumber = (currentPage - 1) * 50 + index + 1;

                                      return (
                                        <tr key={student.student_id} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                          <td data-label="Sl No" style={{ textAlign: 'center', verticalAlign: 'middle' }}>{serialNumber}</td>
                                          {/* <td data-label="APAAR Id" style={{ textAlign: 'center', verticalAlign: 'middle' }}>{student.apaar_no}</td> */}
                                          <td data-label="PRN" style={{ textAlign: 'center', verticalAlign: 'middle' }}>{student.PRN}</td>
                                          <td data-label="APAAR Id" style={{ textAlign: 'center', verticalAlign: 'middle' }}>{student.apaar_no}</td>
                                          <td data-label="Name" style={{ textAlign: 'center', verticalAlign: 'middle' }}>{student.studentname}</td>

                                          <td data-label="View" style={{ textAlign: 'center', verticalAlign: 'middle' }}>

                                            {/* <a class="btn btn-transparent btn-sm" href="javascript:void(0)"><i class="fa fa-link"></i> View profile</a> */}
                                            <ul className="action">
                                              <li className="btn btn-transparent btn-sm"> <Link to={`/college/studentcoattainmentprofile/${encodeExamID(selectExamId)}/${encodeAccountID(student.accountid)}`} target="_blank">
                                                <i class="fa fa-link"></i>&nbsp;View</Link></li>
                                            </ul>
                                          </td>
                                        </tr>
                                      )
                                    }
                                    ) : (
                                      <tr>
                                        <td colSpan="5" className="text-center">No students found</td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                              {/* //pagination logic  */}

                              {totalPages > 1 && (
                                <nav aria-label="..." style={{ cursor: "pointer" }}>
                                  <ul className="pagination justify-content-center">
                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                      <span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
                                    </li>
                                    <li className={`page-item`}>
                                      <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                                    </li>
                                    {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                                    {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                                      <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                        <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                                      </li>
                                    ))}
                                    {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

                                    <li className={`page-item`}>
                                      <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                                    </li>

                                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                      <span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
                                    </li>
                                  </ul>
                                </nav>
                              )}
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Template>
    </>
  );
}